// extracted by mini-css-extract-plugin
export default {"linkIcon":"IGKTiNfvzMQW_XVqyAMQ","fadeIn":"Cupcq1HFdnE4QtaiByqI"};